import { NavKeys } from '@common-modules/dependencies/navigation/nav-keys.enum';
import { AppPermissionsSettings } from '@common-modules/shared/auth/services/app-permissions-settings';

export const cloudTwinAppPermissions: AppPermissionsSettings = {
  routePermissions: new Map<NavKeys, [string, string][]>([]),
  permissionsHierarchy: new Map<NavKeys, NavKeys>(),
};
